import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    GetProductCollectionRealTimePriceApiV2Parameter,
    getProductCollectionRealTimePrices,
} from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = GetProductCollectionRealTimePriceApiV2Parameter &
    HasOnSuccess<RealTimePricingModel> &
    HasOnError<unknown>;

interface Props {
    apiResult: RealTimePricingModel;
    apiParameter: GetProductCollectionRealTimePriceApiV2Parameter;
    error?: unknown;
}

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    const session = getSession(props.getState());
    const userRoles = session.userRoles;
    const settings = props.getState().context.settings.properties;
    const customBuyerRoleName = settings?.customBuyerRoleName || "";

    if (customBuyerRoleName && userRoles && userRoles.toLowerCase().includes(customBuyerRoleName.toLowerCase())) {
        return false;
    }

    if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
        return false;
    }

    try {
        props.apiResult = await getProductCollectionRealTimePrices(props.apiParameter);
    } catch (error) {
        if (error.status === 403) {
            // auth timed out with sign in required for pricing - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
            throw error;
        } else {
            logger.warn(`Failed to load pricing data: ${error}`);
            props.error = error;
        }
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);
